import { useGraphQLQuery } from '@betterment/js-runtime';
import { ErrorBoundary } from '@betterment/shared-components';

import { EnvelopeItem } from './components/EnvelopeItem';
import { EnvelopesDocument } from './graphql/query.envelopes.generated';

import { ListShimmer } from '../ListShimmer';

const EnvelopeNavLinksView: React.FC = () => {
  const { data } = useGraphQLQuery(EnvelopesDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data) return <ListShimmer />;
  if (!data.envelopes || !data.envelopes.length) return null;

  return data.envelopes.map(envelope => <EnvelopeItem key={envelope.id} envelope={envelope} />);
};

export const EnvelopeNavLinks = () => {
  return (
    <ErrorBoundary fallbackType="inline" feature="sidebar" owner="user_engagement">
      <EnvelopeNavLinksView />
    </ErrorBoundary>
  );
};
